import React, { Component } from "react";
import {
  alert, toFixed, format_date, GET, PUT, loading, Status,
  DateRangePicker, Navbar, Modal, profile, required, float, Select
} from "../../components/CustomComponent.js";
import Footer from "../../components/Footer.js";
import { report_preorder, report_tax_invoice } from "../../components/Report.js";
import LOGOLARGE from "../../assets/images/logo512.png";

import Dropdown from "react-bootstrap/Dropdown";
import TH_PROVINCE from "../../assets/files/th_province.json";
import "bootstrap/dist/css/bootstrap.min.css";

export default class DepositsWithdrawals extends Component {
  constructor(props) {
    super(props);
    const today = new Date();
    this.state = {
      addresses: [],
      selectedAddressId: "",
      addressLoading: false,
      addressSubmitting: false,
      showAddAddressForm: false,
      newAddress: {
        uid: "",
        contact_name: profile?.full_name || "",
        contact_phone: profile?.phone || "",
        contact_email: profile?.email || "",
        address: "",
        sub_district: "",
        district: "",
        province: "",
        zipcode: "",
        country: "Thailand",
        is_default: false,
        remark: "",
        is_active: true,
      },
    };
  }

  async componentDidMount() {
    loading(false)
    await this.loadCustomerAddresses();
  }

    getDefaultNewAddress = () => ({
      uid: "",
      contact_name: profile?.full_name || "",
      contact_phone: profile?.phone || "",
      contact_email: profile?.email || "",
      address: "",
      sub_district: "",
      district: "",
      province: "",
      zipcode: "",
      country: "Thailand",
      is_default: false,
      remark: "",
      is_active: true,
    });
    getAddressTitle = (item, index) =>
      item.is_default ? "ที่อยู่หลัก" : `ที่อยู่จัดส่ง ${index + 1}`;
    getAddressSubtitle = (item) => {
      const parts = [
        item.sub_district,
        item.district,
        item.province,
        item.zipcode,
        item.country,
      ].filter(Boolean);
      return parts.join(" ");
    };
    hasCompleteDeliveryInfo = (address) => {
      if (!address) return false;
      return [
        address.contact_name,
        address.contact_phone,
        address.address,
        address.sub_district,
        address.district,
        address.province,
        address.zipcode,
      ].every((value) => `${value || ""}`.trim());
    };
    loadCustomerAddresses = async () => {
      const customerUid =
        profile?.customer?.uid || process.env.REACT_APP_CUSTOMER_ID_DEFAULT || "";
      console.log("loadCustomerAddresses - customerUid:", customerUid);
      if (!customerUid) return;
  
      this.setState({ addressLoading: true });
      const result = await GET("v1/public/market/customer-address", {
        uid: customerUid,
      });
  
      if (result?.status) {
        const addresses = Array.isArray(result?.data) ? result.data : [];
        const selectedAddressId =
          localStorage.getItem("selected_shipping_address_id") ||
          addresses.find((item) => item.is_default)?.uid ||
          addresses[0]?.uid ||
          "";
        localStorage.setItem(
          "selected_shipping_address_id",
          selectedAddressId || "",
        );
        this.setState({
          addresses,
          selectedAddressId,
          addressLoading: false,
        });
        return;
      }else{
            localStorage.clear();
            alert("/", "warning", "แจ้งเตือน", "เซสชันหมดอายุ กรุณาเข้าสู่ระบบใหม่อีกครั้ง");
          }
  
      this.setState({ addressLoading: false });
    };
    syncAddresses = async (addresses, selectedAddressId) => {
      const customerUid =
        profile?.customer?.uid || process.env.REACT_APP_CUSTOMER_ID_DEFAULT || "";
      console.log("syncAddresses - customerUid:", customerUid);
      if (!customerUid) {
        alert("", "warning", "แจ้งเตือน", "ไม่พบข้อมูลลูกค้า");
        return false;
      }
  
      this.setState({ addressSubmitting: true });
      loading(true);
      const result = await PUT(`v1/public/market/customer/${customerUid}`, {
        uid: customerUid,
        address_list: addresses.map((item) => ({
          ...(item.uid ? { uid: item.uid } : {}),
          contact_name: item.contact_name || "",
          contact_phone: item.contact_phone || "",
          contact_email: item.contact_email || "",
          address: item.address || "",
          sub_district: item.sub_district || "",
          district: item.district || "",
          province: item.province || "",
          zipcode: item.zipcode || "",
          country: item.country || "Thailand",
          is_default: !!item.is_default,
          remark: item.remark || "",
          is_active: item.is_active !== false,
        })),
      });
      loading(false);
      this.setState({ addressSubmitting: false });
  
      if (!result?.status) {
        return false;
      }
  
      localStorage.setItem(
        "selected_shipping_address_id",
        selectedAddressId || "",
      );
      await this.loadCustomerAddresses();
      if (selectedAddressId) {
        this.setState({ selectedAddressId });
      }
      return true;
    };
    handleAddressInputChange = (key, value) => {
      this.setState((prevState) => ({
        newAddress: {
          ...prevState.newAddress,
          [key]: value,
        },
      }));
    };
    getProvinceOptions = () => TH_PROVINCE || [];
    getDistrictOptions = (provinceName) =>
      this.getProvinceOptions().find((item) => item.th === provinceName)
        ?.district || [];
    getSubDistrictOptions = (provinceName, districtName) =>
      this.getDistrictOptions(provinceName).find(
        (item) => item.th === districtName,
      )?.sub_district || [];
    getProvinceSelectOptions = () =>
      this.getProvinceOptions().map((item) => ({
        value: item.th,
        label: item.th,
      }));
    getDistrictSelectOptions = (provinceName) =>
      this.getDistrictOptions(provinceName).map((item) => ({
        value: item.th,
        label: item.th,
      }));
    getSubDistrictSelectOptions = (provinceName, districtName) =>
      this.getSubDistrictOptions(provinceName, districtName).map((item) => ({
        value: item.th,
        label: item.th,
      }));
    handleProvinceChange = (province) => {
      this.setState((prevState) => ({
        newAddress: {
          ...prevState.newAddress,
          province,
          district: "",
          sub_district: "",
          zipcode: "",
        },
      }));
    };
    handleDistrictChange = (district) => {
      this.setState((prevState) => ({
        newAddress: {
          ...prevState.newAddress,
          district,
          sub_district: "",
          zipcode: "",
        },
      }));
    };
    handleSubDistrictChange = (subDistrict) => {
      this.setState((prevState) => {
        const selectedSubDistrict = this.getSubDistrictOptions(
          prevState.newAddress.province,
          prevState.newAddress.district,
        ).find((item) => item.th === subDistrict);
  
        return {
          newAddress: {
            ...prevState.newAddress,
            sub_district: subDistrict,
            zipcode: selectedSubDistrict?.code?.toString() || "",
          },
        };
      });
    };
    openAddAddressForm = () => {
      this.setState({
        showAddAddressForm: true,
        newAddress: this.getDefaultNewAddress(),
      });
    };
    closeAddAddressForm = () => {
      this.setState({
        showAddAddressForm: false,
        newAddress: this.getDefaultNewAddress(),
      });
    };
    addNewAddress = async () => {
      const { addresses, newAddress } = this.state;
      if (!newAddress.contact_name.trim()) {
        alert("", "warning", "แจ้งเตือน", "กรุณากรอกชื่อผู้รับ");
        return;
      }
      if (!newAddress.contact_phone.trim()) {
        alert("", "warning", "แจ้งเตือน", "กรุณากรอกเบอร์โทร");
        return;
      }
      if (!newAddress.address.trim()) {
        alert("", "warning", "แจ้งเตือน", "กรุณากรอกที่อยู่จัดส่ง");
        return;
      }
      if (!newAddress.province.trim()) {
        alert("", "warning", "แจ้งเตือน", "กรุณาเลือกจังหวัด");
        return;
      }
      if (!newAddress.district.trim()) {
        alert("", "warning", "แจ้งเตือน", "กรุณาเลือกเขต/อำเภอ");
        return;
      }
      if (!newAddress.sub_district.trim()) {
        alert("", "warning", "แจ้งเตือน", "กรุณาเลือกแขวง/ตำบล");
        return;
      }
      loading(true);
  
      const createdAddress = {
        ...newAddress,
        is_default: addresses.length === 0,
      };
      const nextAddresses = [...addresses, createdAddress].map((item, index) => ({
        ...item,
        is_default: createdAddress.is_default
          ? index === addresses.length
          : item.is_default,
        is_active: item.is_active !== false,
      }));
  
      console.log("selectedAddressId:", this.state.selectedAddressId);
      console.log("nextAddresses:", nextAddresses);
  
      const isSuccess = await this.syncAddresses(
        nextAddresses,
        this.state.selectedAddressId,
      );
      if (!isSuccess) return;
  
      this.setState({
        showAddAddressForm: false,
        newAddress: this.getDefaultNewAddress(),
      });
  
      loading(false);
    };
    selectAddress = (id) => {
      localStorage.setItem("selected_shipping_address_id", id);
      this.setState({ selectedAddressId: id });
    };
    setDefaultAddress = async (id) => {
      const { addresses } = this.state;
      const nextAddresses = addresses.map((item) => ({
        ...item,
        is_default: item.uid === id,
      }));
      const isSuccess = await this.syncAddresses(nextAddresses, id);
      if (!isSuccess) return;
      this.setState({ selectedAddressId: id });
    };
    removeAddress = async (id) => {
      const { addresses, selectedAddressId } = this.state;
      if (addresses.length <= 1) {
        alert(
          "",
          "warning",
          "แจ้งเตือน",
          "ต้องมีที่อยู่จัดส่งอย่างน้อย 1 รายการ",
        );
        return;
      }
      if (
        !(await alert(
          "",
          "warning",
          "ยืนยันการลบ",
          "ต้องการลบที่อยู่นี้หรือไม่?",
          "ลบ",
          "ยกเลิก",
        ))
      ) {
        return;
      }
  
      const nextAddresses = addresses
        .map((item) =>
          item.uid === id
            ? {
                ...item,
                is_active: false,
                is_default: false,
              }
            : item,
        )
        .filter((item) => item.uid !== id || item.is_active !== false);
      const hasDefault = nextAddresses.some((item) => item.is_default);
      if (!hasDefault && nextAddresses[0]) {
        nextAddresses[0].is_default = true;
      }
      const nextSelectedAddressId = nextAddresses.some(
        (item) => item.uid === selectedAddressId,
      )
        ? selectedAddressId
        : nextAddresses[0]?.uid || "";
  
      const syncPayload = addresses.map((item) =>
        item.uid === id
          ? {
              ...item,
              is_active: false,
              is_default: false,
            }
          : item,
      );
  
      const isSuccess = await this.syncAddresses(
        syncPayload,
        nextSelectedAddressId,
      );
      if (!isSuccess) return;
  
      this.setState({ selectedAddressId: nextSelectedAddressId });
    };

  render() {
    const { addresses, selectedAddressId, addressLoading, addressSubmitting, showAddAddressForm, newAddress } = this.state;
 const provinceOptions = this.getProvinceSelectOptions();
    const districtOptions = this.getDistrictSelectOptions(newAddress.province);
    const subDistrictOptions = this.getSubDistrictSelectOptions(
      newAddress.province,
      newAddress.district,
    );
    const selectedAddress =
      addresses.find((item) => item.uid === selectedAddressId) || null;
    const canSubmit = this.hasCompleteDeliveryInfo(selectedAddress);
    return (
      <div className="w-100 min-vh-100">
        <Navbar />
        <div className="row d-flex justify-content-center mx-0">
         <div className="col-12 col-sm-11 col-md-10 col-lg-2 col-xl-2 pt-5 mt-3 d-none d-lg-block">
                     {/* ชื่อผู้ใช้ */}
                     <div className="d-flex align-items-center text-start">
                       <span className="bg-orange text-dark me-1 wpx-50 hpx-50 text-24 rounded-circle d-flex align-items-center justify-content-center">
                         ลค
                       </span>
                       <div className="px-2 ">
                         <div className="text-14 fw-bold">{profile?.full_name || "ลูกค้าทั่วไป"}</div>
                         <div className="text-12 text-dark" style={{ marginTop: -2 }}>
                           {profile?.phone || "-"}
                         </div>
                       </div>
                     </div>
                     {/* เมนู */}
                     <div className="py-3">
                       <a href="/profile" className="d-flex justify-content-between pt-2 pb-2 border-bottom text-decoration-none text-dark" rel="noreferrer">
                         <div className="d-flex"><span className="icon me-2">{"\uf007"}</span>บัญชีของฉัน</div>
                       </a>
                       <a href="/address" className="d-flex justify-content-between pt-2 pb-2 border-bottom text-decoration-none text-dark" rel="noreferrer">
                         <div className="d-flex"><span className="icon me-2">{"\uf015"}</span>ที่อยู่ของฉัน</div>
                       </a>
                       <a href="/change-password" className="d-flex justify-content-between pt-2 pb-2 border-bottom text-decoration-none text-dark" rel="noreferrer">
                         <div className="d-flex"><span className="icon me-2">{"\uf084"}</span>เปลี่ยนรหัสผ่าน</div>
                       </a>
                       <a href="/transaction" className="d-flex justify-content-between pt-2 pb-2 border-bottom text-decoration-none text-dark" rel="noreferrer">
                         <div className="d-flex"><span className="icon me-2">{"\uf570"}</span>การซื้อของฉัน</div>
                       </a>
                     </div>
                   </div>
          <div className="col-12 col-sm-11 col-md-10 col-lg-9 col-xl-7 col-xxl-6 my-4 px-3 min-vh-100">
            <h4 className="fw-bold mb-3">ที่อยู่ของฉัน</h4>
            <div className="rounded-4 bg-white p-3 mb-3">
              <div className="d-flex justify-content-between align-items-center mb-2">
                        <div className="fw-bold mb-0">ที่อยู่ในการจัดส่ง</div>
                        <div className="d-flex align-items-center">
                          <span className="badge text-bg-light">
                            {addresses.length} รายการ
                          </span>
                          <button
                          type="button"
                          className="btn bg-orange text-white rounded-4 ms-2"
                          onClick={this.openAddAddressForm}
                        >
                          เพิ่มที่อยู่ใหม่
                        </button>
                        </div>
                      </div>
                      {addressLoading && (
                        <div className="bg-secondary-light rounded-4 p-3 mb-3 text-secondary">
                          กำลังโหลดที่อยู่...
                        </div>
                      )}
                      <div className="mb-3">
                        {addresses.length > 0 ? (
                          addresses.map((item, index) => (
                            <div
                              key={item.uid}
                              role="button"
                              tabIndex={0}
                              className={`w-100 text-start border rounded-4 p-3 mb-2 border-secondary`}
                              style={{
                                boxShadow: "none",
                                cursor: "pointer",
                                backgroundColor: 'unset'
                              }}
                              onClick={() => this.selectAddress(item.uid)}
                              onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === " ") {
                                  e.preventDefault();
                                  this.selectAddress(item.uid);
                                }
                              }}
                            >
                              <div className="d-flex justify-content-between align-items-start gap-2 flex-wrap mb-2">
                                <div>
                                  <div className="fw-bold d-flex align-items-center gap-2 flex-wrap">
                                    <span>
                                      {this.getAddressTitle(item, index)}
                                    </span>
                                    {item.is_default && (
                                      <span className="badge bg-orange text-white">
                                        ค่าเริ่มต้น
                                      </span>
                                    )}
                                  </div>
                                  <div className="text-secondary small">
                                    {item.contact_name || "-"} |{" "}
                                    {item.contact_phone || "-"}
                                  </div>
                                  {!!item.contact_email && (
                                    <div className="text-secondary small">
                                      {item.contact_email}
                                    </div>
                                  )}
                                </div>
                                 <Dropdown>
                                                  <Dropdown.Toggle variant="gray" id="dropdown-basic" size="sm">จัดการ</Dropdown.Toggle>
                                                  <Dropdown.Menu className="shadow overflow-hidden border-0 rounded-4 p-2">
                                                    {!item.is_default && (<Dropdown.Item className="rounded-3 d-flex align-items-center px-2" onClick={(e) => {
                                        e.stopPropagation();
                                        this.setDefaultAddress(item.uid);
                                      }}>
                                                      <div className="fw-bold icon me-1 wpx-15 text-center text-12">{"\uf005"}</div> ตั้งเป็นที่อยู่หลัก
                                                    </Dropdown.Item>)}
                                                      <Dropdown.Item className={`settlements-hq.update rounded-3 d-flex align-items-center px-2 text-danger`} onClick={(e) => {
                                      e.stopPropagation();
                                      this.removeAddress(item.uid);
                                    }}>
                                                        <div className="fw-bold icon me-1 wpx-15 text-center text-12">{"\uf1f8"}</div> ลบ
                                                      </Dropdown.Item>
                                                  </Dropdown.Menu>
                                                </Dropdown>
                              </div>
                              <div className="small fw-bold mb-1">
                                {item.address || "-"}
                              </div>
                              {!!this.getAddressSubtitle(item) && (
                                <div className="text-secondary small">
                                  {this.getAddressSubtitle(item)}
                                </div>
                              )}
                              {item.remark && (
                                <div className="text-secondary small">
                                  หมายเหตุ: {item.remark}
                                </div>
                              )}
                            </div>
                          ))
                        ) : (
                          <div className="bg-secondary-light rounded-4 p-3 text-secondary">
                            ยังไม่มีที่อยู่จัดส่ง
                          </div>
                        )}
                      </div>
            </div>

          </div>
        </div>

<Modal
          show={showAddAddressForm}
          onHide={() => this.setState({ showAddAddressForm: false })}
        >
          <Modal.Header className="border-0" closeButton>
            <h5 className="fw-bold mb-0">
              เพิ่มที่อยู่ใหม่
            </h5>
          </Modal.Header>
          <Modal.Body>
                          <div className="row">
                            <div className="col-12 mb-3">
                              <label className="form-label text-secondary mb-1">
                                ชื่อผู้รับ{required}
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="ชื่อผู้รับ"
                                value={newAddress.contact_name}
                                onChange={(e) =>
                                  this.handleAddressInputChange(
                                    "contact_name",
                                    e.target.value,
                                  )
                                }
                              />
                            </div>
                            <div className="col-12 mb-3">
                              <label className="form-label text-secondary mb-1">
                                เบอร์โทร{required}
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="เบอร์โทร"
                                maxLength={10}
                                value={newAddress.contact_phone}
                                onChange={(e) => {
                                  if (!float(e.target.value)) return;
                                  this.handleAddressInputChange(
                                    "contact_phone",
                                    e.target.value,
                                  );
                                }}
                              />
                            </div>
                            <div className="col-12 mb-3">
                              <label className="form-label text-secondary mb-1">
                                อีเมลติดต่อ
                              </label>
                              <input
                                type="email"
                                className="form-control"
                                placeholder="อีเมลติดต่อ"
                                value={newAddress.contact_email}
                                onChange={(e) =>
                                  this.handleAddressInputChange(
                                    "contact_email",
                                    e.target.value,
                                  )
                                }
                              />
                            </div>
                            <div className="col-12 mb-3">
                              <label className="form-label text-secondary mb-1">
                                ที่อยู่จัดส่ง{required}
                              </label>
                              <textarea
                                rows={4}
                                className="form-control"
                                placeholder="บ้านเลขที่ หมู่ ซอย ถนน ตำบล/แขวง อำเภอ/เขต จังหวัด รหัสไปรษณีย์"
                                value={newAddress.address}
                                onChange={(e) =>
                                  this.handleAddressInputChange(
                                    "address",
                                    e.target.value,
                                  )
                                }
                              />
                            </div>
                            <div className="col-12 mb-3">
                              <label className="form-label text-secondary mb-1">
                                จังหวัด{required}
                              </label>
                              <Select
                                className="form-control"
                                options={provinceOptions}
                                value={newAddress.province}
                                placeholder="เลือกจังหวัด"
                                onChange={(value) =>
                                  this.handleProvinceChange(value)
                                }
                              />
                            </div>
                            <div className="col-12 mb-3">
                              <label className="form-label text-secondary mb-1">
                                เขต/อำเภอ{required}
                              </label>
                              <Select
                                className="form-control"
                                options={districtOptions}
                                value={newAddress.district}
                                placeholder="เลือกเขต/อำเภอ"
                                onChange={(value) =>
                                  this.handleDistrictChange(value)
                                }
                                disabled={!newAddress.province}
                              />
                            </div>
                            <div className="col-12 mb-3">
                              <label className="form-label text-secondary mb-1">
                                แขวง/ตำบล{required}
                              </label>
                              <Select
                                className="form-control"
                                options={subDistrictOptions}
                                value={newAddress.sub_district}
                                placeholder="เลือกแขวง/ตำบล"
                                onChange={(value) =>
                                  this.handleSubDistrictChange(value)
                                }
                                disabled={
                                  !newAddress.province || !newAddress.district
                                }
                              />
                            </div>
                            <div className="col-12 mb-3">
                              <label className="form-label text-secondary mb-1">
                                รหัสไปรษณีย์
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="รหัสไปรษณีย์จะขึ้นอัตโนมัติ"
                                maxLength={10}
                                value={newAddress.zipcode}
                                readOnly
                              />
                            </div>
                            <div className="col-12 mb-3">
                              <label className="form-label text-secondary mb-1">
                                หมายเหตุเพิ่มเติม
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="เช่น ฝากไว้หน้าร้าน หรือ โทรก่อนส่ง"
                                value={newAddress.remark}
                                onChange={(e) =>
                                  this.handleAddressInputChange(
                                    "remark",
                                    e.target.value,
                                  )
                                }
                              />
                            </div>
                          </div>
                        </Modal.Body>
                         <Modal.Footer className="pt-0 border-0 d-flex justify-content-end">
            <button
              className="btn btn-dark px-5 me-1"
              onClick={() => {
                this.addNewAddress();
              }}
            >
              submit
            </button>
            <button
              className="btn btn-outline-dark px-5 ms-1"
              onClick={() => {
                this.closeAddAddressForm();
              }}
            >
              cancel
            </button>
          </Modal.Footer>
                        </Modal>
        
        <Footer />
      </div>
    );
  }
}